<template>
    <b-modal
            :ok-only="true"
            size="xl"
            title="QR Scan"
            :id="id">
        <b-container>
            <b-row>
                <b-col v-if="error">
                    <b-alert variant="warning" show>Could not find or access camera.</b-alert>
                </b-col>
                <b-col v-else>
                    <qrcode-stream @click.native="redirectToDecodedUrl()" @init="onInit" @decode="onDecode" @camera="selectedCamera"></qrcode-stream>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>


<script>

    export default {
        name: 'qr-search',
        components: {},
        props: {
            id: String
        },
        data: function () {
            return {
                busy: false,
                selectedCamera: "rear",
                error: "",
                lastDecodedUrl: null
            }
        },
        methods: {
            redirectToDecodedUrl() {
                if(this.lastDecodedUrl) {
                    window.location.href = this.lastDecodedUrl;
                }
            },
            onDecode(decodedString) {
                if (decodedString) {
                    this.lastDecodedUrl = decodedString;
                }
            },
            onInit(qrCodePromise) {
                return qrCodePromise.catch((error) => {
                    this.error = error;
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";


</style>
